import "./index.css";
import React, { useState, useEffect, useRef } from "react";
import { useHistory, useLocation } from "react-router-dom";
import Header from "../../components/Header";
import Firebase from "../../firebasehelper";
import AddFeaturedContentModal from "../HotTopic/AddFeaturedContentModal";
import ContentSection from "./components/ContentSection";
import ConfirmationModal from "../../components/ConfirmationModal";

export default function FeaturedContent() {
  const [isLoading, setLoading] = useState(true);
  const [brandData, setBrandData] = useState({});
  const [userType, setUserType] = useState("prospect");
  const [selectedContent, setSelectedContent] = useState();
  const [featuredContent, setFeaturedContent] = useState({
    members: [],
    prospects: [],
  });
  const [headerData, setHeaderData] = useState({
    username: "",
    brandId: "",
    role: "",
    is_property_brand: "",
    is_supportchat_needed: "",
    is_programmetool_need: "",
  });

  const addContentModalRef = useRef();
  const history = useHistory();
  const location = useLocation();

  const getData = async () => {
    const { brand: brandId } = location.state;

    Firebase.getBrandDataByID(brandId, (brandDataResponse) => {
      if (!brandDataResponse) return;

      const {
        is_programmetool_need,
        is_supportchat_needed,
        is_property_brand,
      } = brandDataResponse;

      setBrandData(brandDataResponse);
      setHeaderData({
        username: location.state.username,
        role: location.state.role,
        brandId: brandId,
        is_property_brand: is_property_brand ? is_property_brand : false,
        is_supportchat_needed: is_supportchat_needed
          ? is_supportchat_needed
          : false,
        is_programmetool_need: is_programmetool_need
          ? is_programmetool_need
          : false,
      });
      getFeaturedContent(brandDataResponse.name);
    });
  };

  const getFeaturedContent = (brandName) => {
    Firebase.getAllFeaturedContent(brandName, (featuredContent) => {
      const membersContent = featuredContent
        .filter((v) => v.toMembers === undefined || v.toMembers === true)
        .sort((a, b) => a.starting_monday.seconds - b.starting_monday.seconds);
      const prospectContent = featuredContent
        .filter((v) => v.toReferrals === undefined || v.toReferrals === true)
        .sort((a, b) => a.starting_monday.seconds - b.starting_monday.seconds);

      setFeaturedContent({
        members: membersContent,
        prospects: prospectContent,
      });
      setLoading(false);
    });
  };

  useEffect(() => {
    if (!location.state) {
      history.push("/");
      return;
    }
    getData();
  }, []);

  const onUploadCardClick = (userType) => {
    setUserType(userType);
    addContentModalRef.current.click();
  };

  const isValidDate = (date) => {
    const tempDate = new Date(date);

    // Check if the new Date object is valid
    // A Date object with an invalid date returns NaN when calling getTime()
    return !isNaN(tempDate.getTime());
  };

  const sortDatesAscending = (a, b) => {
    // Note: we have to account for a mismatch in timestamp formats here.
    // Existing contentItems use a server timestamp e.g. {seconds: 123543532, nanoseconds: 34456033}
    // while the newContentItem uses a UTC timestamp
    const tempDateA = new Date(a.starting_monday.seconds * 1000);
    const tempDateB = new Date(b.starting_monday.seconds * 1000);

    const DateA = isValidDate(tempDateA) ? tempDateA : a.starting_monday;
    const DateB = isValidDate(tempDateB) ? tempDateB : b.starting_monday;

    return DateA - DateB;
  };

  const uploadFeaturedContent = (payload) => {
    let memberContent = [...featuredContent.members];
    let prospectContent = [...featuredContent.prospects];

    Firebase.addFeaturedContent(payload, brandData.name).then((res) => {
      const newContentItem = { ...payload, id: res.id };
      if (payload.toMembers) {
        memberContent = [...memberContent, newContentItem];
      }
      if (payload.toReferrals) {
        prospectContent = [...prospectContent, newContentItem];
      }

      setFeaturedContent({
        members: memberContent.sort((a, b) => sortDatesAscending(a, b)),
        prospects: prospectContent.sort((a, b) => sortDatesAscending(a, b)),
      });
    });
  };

  const onDelete = async () => {
    try {
      await Firebase.deleteFeaturedContent(
        brandData.name,
        selectedContent.id,
        selectedContent.media_url,
        selectedContent.media_type
      );

      // remove from state
      if (selectedContent.toReferrals) {
        setFeaturedContent({
          ...featuredContent,
          prospects: featuredContent.prospects.filter(
            (content) => content.id !== selectedContent.id
          ),
        });
      } else {
        setFeaturedContent({
          ...featuredContent,
          members: featuredContent.members.filter(
            (content) => content.id !== selectedContent.id
          ),
        });
      }
    } catch (err) {
      console.error("onDelete", err);
    }
  };

  return isLoading ? (
    <main className="featured-content__loading">
      <i className="fa fa-3x fa-sync fa-spin text-muted" />
    </main>
  ) : (
    <main className="featured-content">
      <Header
        username={headerData.username}
        role={headerData.role}
        logo={brandData.logo}
        brand={headerData.brandId}
        brandName={brandData.name}
        is_property_brand={headerData.is_property_brand}
      />
      <section className="featured-content__section">
        <div className="featured-content__top-container">
          <h1 className="featured-content__main-title">
            Upload featured content to your Explore page
          </h1>
        </div>
        <div className="featured-content__bottom-container">
          <ContentSection
            featuredContent={featuredContent}
            onUploadCardClick={onUploadCardClick}
            hex={brandData.hex}
            setSelectedContent={setSelectedContent}
          />
        </div>
      </section>
      <button
        style={{ display: "none" }}
        data-toggle="modal"
        data-target="#add_featuredContent_modal"
        ref={addContentModalRef}
      />
      <AddFeaturedContentModal
        uploadFeaturedContent={uploadFeaturedContent}
        featuredContent={featuredContent}
        territory={brandData.territory}
        brand={brandData.name}
        userType={userType}
        hex={brandData.hex}
        white={brandData.white}
      />
      <ConfirmationModal
        id="delete_modal"
        type="content"
        onClick={onDelete}
        hex={brandData.hex}
        white={brandData.white}
        classNames="delete-modal__delete-btn"
      />
    </main>
  );
}



// WEBPACK FOOTER //
// ./src/screens/FeaturedContent/index.js